var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shim",style:({ zIndex: _vm.zIndex})},[_vm._t("overlay",function(){return [(_vm.overlay)?_c('div',{staticClass:"shim-overlay"}):_vm._e()]}),_c('div',{staticClass:"shim-content w-100 h-100 d-flex flex-center"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }